<div id="academy-course" class="divback">
  <div class="" fxLayout="row" fxLayoutAlign="space-between start" fxFlex="100">
    <div class="Introduccion" fxLayout="column"  fxFlex="80" fxHide fxShow.gt-xs>
      <div class="text">
        <h3 class="text2" >{{'LOGIN-ENCUESTADOR.INTRO-LOGIN.TITULO' | translate}}</h3>
        <p>{{'LOGIN-ENCUESTADOR.INTRO-LOGIN.TEXT1' | translate}}</p>
        <p class="text2">{{'LOGIN-ENCUESTADOR.INTRO-LOGIN.TEXT2' | translate}}</p>
        <p>{{'LOGIN-ENCUESTADOR.INTRO-LOGIN.TEXT3' | translate}}</p>

        <span class="">{{'LOGIN-ENCUESTADOR.INTRO-LOGIN.TEXT4' | translate}}
          <br>
          <span >{{'LOGIN-ENCUESTADOR.INTRO-LOGIN.TEXT5' | translate}}</span>
          <br>
          <span ><span class="text2">FS-MEXICO</span> {{'LOGIN-ENCUESTADOR.INTRO-LOGIN.TEXT6' | translate}}</span>
          <br>
          {{'LOGIN-ENCUESTADOR.INTRO-LOGIN.TEXT7' | translate}}
          <!-- <span ></span> -->
        </span>
        <br>
        <br>
        <span class=""><span class="text2">{{'LOGIN-ENCUESTADOR.INTRO-LOGIN.TEXT8' | translate}}</span> {{'LOGIN-ENCUESTADOR.INTRO-LOGIN.TEXT9' | translate}}
        <br>
        <span>{{'LOGIN-ENCUESTADOR.INTRO-LOGIN.TEXT10' | translate}}</span>
        <br>
        <span >{{'LOGIN-ENCUESTADOR.INTRO-LOGIN.TEXT11' | translate}}</span>
        <br>
        {{'LOGIN-ENCUESTADOR.INTRO-LOGIN.TEXT12' | translate}}
        <!-- <span ></span> -->
      </span>

      <h3 class="text2">{{'LOGIN-ENCUESTADOR.INTRO-LOGIN.TEXT13' | translate}}</h3>

      <span>{{'LOGIN-ENCUESTADOR.INTRO-LOGIN.TEXT14' | translate}}<span class="text2" >{{'LOGIN-ENCUESTADOR.INTRO-LOGIN.TEXT15' | translate}}</span>
      <br>
      <span>{{'LOGIN-ENCUESTADOR.INTRO-LOGIN.TEXT16' | translate}}</span>
      <br>
      <span>{{'LOGIN-ENCUESTADOR.INTRO-LOGIN.TEXT17' | translate}}</span>
      <br>
      <p>{{'LOGIN-ENCUESTADOR.INTRO-LOGIN.TEXT18' | translate}}</span>

      </div>
    </div>

    <div class="login" fxLayout="column" layout.gt-xs="100%" fxLayoutAlign.gt-xs="center">
      <div class="imagenInstituto" fxFlex.gt-xs="10%">
        <img src="./assets\images\logos/gptw.jpg" alt="">
      </div>
      <h6 class="card-subtitle line-on-side text-muted text-center font-small-3 pt-2">
        <span id="dynLoginMsgAccess">Acceso</span>
      </h6>

      <div class="language" >
        <!--------selector de idiomas--->
        <form class="">
          <mat-form-field appearance="outline">
            <mat-label>{{'LOGIN-ENCUESTADOR.FORM.INPUT.LANGSEL' | translate}}</mat-label>
            <mat-select [(value)]="selectedLanguage" required>
              <mat-option *ngFor="let lang of languages" (click)="setLanguage(lang.id)" [value]="lang.id">
                {{'NOMBREIDIOMAS.'+lang.id | translate}}
              </mat-option>
            </mat-select>
            <mat-icon matSuffix class="secondary-text">language</mat-icon>
            <mat-error>idioma</mat-error>
          </mat-form-field>
        </form>
      </div>
      <div class="">
        <span class="input-group-addon"><i class="glyphicon glyphicon-lock icon"></i></span>
        <input type="password" placeholder="{{'LOGIN-ENCUESTADOR.FORM.INPUT.PASSWORD' | translate}}" class="form-control border-danger">
      </div>

      <div class="">
        <button type="submit"  class="btn" (click)="navigateToEncuesta('appsurvey/survey')">
          <mat-icon>input</mat-icon>{{'LOGIN-ENCUESTADOR.FORM.INPUT.LOGIN' | translate}} </button>
        </div>
      </div>
    </div>
